import React from 'react';
import styled from 'styled-components';
import { Body5, Container } from '@ui';

const MultiSelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  padding: 12px 16px 14px 16px;

  background: ${({ theme }) => theme.themeColors.lowContrastBorder};
  border-radius: 5px;
  cursor: pointer;

  &:hover .checkbox label::after {
    opacity: 0.3;
  }

  .checkbox {
    position: relative;
    width: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    label {
      width: 20px;
      height: 20px;
      cursor: pointer;
      position: absolute;
      top: 0;
      left: 0;

      //background: linear-gradient(top, #222 0%, #888 100%);
      border: 1px solid ${({ theme }) => theme.themeColors.border};
      border-radius: 2px;

      &:after {
        content: '';
        width: 9px;
        height: 5px;
        position: absolute;
        top: 4px;
        left: 3px;
        border: 3px solid ${({ theme }) => theme.themeColors.primaryCtaButton};
        border-top: none;
        border-right: none;
        opacity: 0;
        transform: rotate(-45deg);
      }

      &:hover::after {
        opacity: 0.3;
      }
    }

    input[type='checkbox'] {
      visibility: hidden;

      &:checked + label:after {
        opacity: 1;
      }
    }
  }
`;

function Item({ isSelected, value, onSelect, onRemove }) {
  const onClick = () => {
    isSelected ? onRemove(value) : onSelect(value);
  };
  return (
    <ItemWrapper onClick={onClick}>
      <div className={'checkbox'}>
        <input
          type="checkbox"
          id="checkbox"
          checked={isSelected}
          onClick={() => null}
          style={{ cursor: 'pointer', marginTop: 0, marginLeft: '0px', width: '14px' }}
          readOnly
        />
        <label className="not-selectable"></label>
      </div>
      <Container left={16} top={2}>
        <Body5 bold>{value}</Body5>
      </Container>
    </ItemWrapper>
  );
}

export const MultiSelect = ({ values, items, onSelectItem, onRemoveItem }) => {
  return (
    <MultiSelectWrapper>
      {items.map((dt) => (
        <Item key={dt} value={dt} isSelected={values.includes(dt)} onSelect={onSelectItem} onRemove={onRemoveItem} />
      ))}
    </MultiSelectWrapper>
  );
};
